<!--
- 数据简报（手机端）
- author: wang.y
- greatTime: 2019-08-07
- 修改人： zjx
- 修改日期： 2019-10-11
- 修改内容： 简报优化，手机端页面样式修改
-->
<template>
    <div class="index">
        <div :class="{header: true, on: isOpen}" v-cloak>
            <img :src="$store.state.static_img_url+'pic/logo.png'">
            <span @click="chapter_list_show = !chapter_list_show" v-if="chapter_params.chapter_id">第{{chapter_num(chapter_params.chapter_id)}}期 {{getDate(chapter_params.chapter_date)}}<i class="iconfont"><template v-if="chapter_list_show">&#xe63b;</template><template v-else>&#xe648;</template></i></span>
        </div>
        <div class="chapter-sel">
            <ul v-if="chapter_list_show">
                <li
                    v-for="item in chapter_list"
                    :key="item.id"
                    :class="{active: chapter_params.chapter_id == item.id}"
                    @click="haddleChangeChapter(item.id,item.publish_time)"
                >
                    <i class="iconfont">&#xe628;</i>
                    <span>第{{item.num}}期 {{getDate(item.publish_time)}}</span>
                </li>
            </ul>
        </div>
        <div class="chapter-meng" v-if="chapter_list_show" @click="chapter_list_show = !chapter_list_show"></div>
        <div :class="{plane: true, on: isOpen}">
            <div class="banner">
                <div class="tle">
                  <div class="logo">
                    <i class="iconfont">&#xe670;</i>
                    <span>动脉微报</span>
                  </div>
                  <p>{{chapter_detail.title}}</p>
                </div>
                <img :src="chapter_detail.banner_path | logo_show" v-if="chapter_detail.banner_path"/>
                <img :src="custom_report_detail.banner_path | logo_show" v-else/>
            </div>
            <div class="content">
                <div class="number clear">
                  <div v-for="item,index in chapter_module" :key="index" @click="haddleModelSlider(item.id)">
                        <div class="number-t">
                            <p>{{item.name}}<i class="iconfont number-icon">&#xe647;</i></p>
                            <p class="number-line"></p>
                        </div>
                        <div class="number-b">
                            <span v-if="module_list[item.id]">{{module_list[item.id].count}}</span>
                        </div>
                    </div>
                </div>
                <div class="summary">
                    <p class="tle">本期摘要</p>
                    <p class="tle-line"></p>
                    <div v-html="chapter_detail.summary"></div>
                </div>
                <div class="abstract">
                  <span><span class="tle">动脉微报</span>{{chapter_detail.description}}</span>
                </div>
                <div class="temps">
                    <div class="temp" v-for="item,index in chapter_module" :key="index" :id="'tempLi' + item.id">
                        <div class="temp-content">
                            <div class="tle">
                              <img :src="$store.state.static_img_url + 'mobile/pic/briefReport/icon_l.png'">
                              <span>{{item.name}}</span>
                              <img :src="$store.state.static_img_url + 'mobile/pic/briefReport/icon_r.png'">
                            </div>
                            <div class="temp-tip" v-if="insight[item.id] && insight[item.id].length > 0">
                                <i class="iconfont">&#xe654;</i>
                                <div v-html="insight[item.id][0].text"></div>
                            </div>
                            <ul class="topic-list" v-if="module_list[item.id] && module_list[item.id]['topic'].length > 0">
                                <li
                                    v-for="topicItem,topicIndex in module_list[item.id]['topic']"
                                    :key="topicIndex"
                                    v-show="topicIndex < 10 || show_all_list[item.id]"
                                >
                                    <p class="topic-tle"><img :src="$store.state.static_img_url + 'mobile/pic/briefReport/slash.png'" class="slash">{{topicItem.title}}</p>
                                    <p class="topic-dec">{{topicItem.content}}</p>
                                </li>
                            </ul>
                            <ul class="project-list" v-if="module_list[item.id] && module_list[item.id]['entity'].length > 0">
                                <li
                                    v-for="entityItem,entityIndex in entity_list(module_list[item.id]['entity'])"
                                    :key="entityIndex"
                                    v-show="entityIndex < 10 || show_all_list[item.id]"
                                >
                                    <div class="pro-title">{{entityItem.short_name}}</div>
                                    <div class="pro-top">
                                        <div class="pro-img">
                                            <div>
                                                <img :src="entityItem.logo_path" />
                                            </div>
                                        </div>
                                        <div class="pro-dec">
                                            <p class="p1">最新轮次：{{entityItem.round_id | dealNeed(round)}}</p>
                                            <p class="p2" v-if="entityItem.latest_event.event_time">融资时间：{{entityItem.latest_event.event_time | time_moment('YYYY-MM-DD')}}</p>
                                        </div>
                                    </div>
                                    <div class="pro-btm">
                                        <div class="pro-sm">
                                            <div class="pro-l"><i class="iconfont">&#xe690;</i><template v-if="entityItem.type == 0">公司</template><template v-if="entityItem.type == 1">机构</template><template v-if="entityItem.type == 3">医院</template>简介</div>
                                            <div class="pro-r">
                                                <p>{{entityItem.summary | empty('暂无简介')}}</p>
                                            </div>
                                        </div>
                                        <div class="pro-sm" v-for="entityItem2 in entityItem.temp" :key="entityItem2.id">
                                            <div class="pro-l"><i class="iconfont">&#xe68e;</i>{{entityItem2.name}}</div>
                                            <div class="pro-r">
                                                <div class="tags">
                                                    <span class="tag" v-for="entityItem3,idx in entityItem2.arr" :key="idx">{{entityItem3.name}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul class="article-list" v-if="module_list[item.id] && module_list[item.id]['art'].length > 0">
                                <li
                                    v-for="artItem,artIndex in module_list[item.id]['art']"
                                    :key="artIndex"
                                    v-show="artIndex < 10 || show_all_list[item.id]"
                                >
                                    <a :href="'https://vcbeat.top/' + filter.changeBase64(artItem.uid)">
                                        <div class="article-img">
                                            <span>文章</span>
                                            <img :src="artItem.logo_path | logo_show" />
                                        </div>
                                        <div class="article-info">
                                            <p class="p1">{{artItem.title}}</p>
                                            <p class="p2">
                                                <span><i class="iconfont">&#xe645;</i>动脉网</span>
                                                <span><i class="iconfont">&#xe632;</i>{{artItem.publish_time | time_moment}}</span>
                                            </p>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            <ul class="article-list" v-if="module_list[item.id] && module_list[item.id]['report'].length > 0">
                                <li
                                    v-for="reportItem,reportIndex in module_list[item.id]['report']"
                                    :key="reportIndex"
                                    v-show="reportIndex < 10 || show_all_list[item.id]"
                                >
                                    <a :href="'https://vcbeat.top/reportDetail?rid=' + reportItem.uid">
                                        <div class="article-img">
                                            <span>报告</span>
                                            <img :src="reportItem.logo_path | logo_show" />
                                        </div>
                                        <div class="article-info">
                                            <p class="p1">{{reportItem.title}}</p>
                                            <p class="p2">
                                                <span v-if="reportItem.src_author"><i class="iconfont">&#xe645;</i>来源：{{reportItem.src_author}}</span>
                                            </p>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            <div class="temp-bottom" v-if="module_list[item.id] && (module_list[item.id]['topic'].length > 10 || module_list[item.id]['entity'].length > 10 || module_list[item.id]['art'].length > 10 || module_list[item.id]['report'].length > 10)">
                                <span class="more-btn" @click="showAllList(item.id)">
                                    <template v-if="!show_all_list[item.id]">查看全部</template>
                                    <template v-else>收起全部</template>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="{'go-back':true,'show-back':scroll_top>360}" @click="goBack()">
              <img :src="$store.state.static_img_url + 'mobile/pic/briefReport/goback.png'">
            </div>
            <div class="footer">
                <ul class="cantact">
                    <li>
                        <p class="cantact-title">技术支持</p>
                        <div class="cantact-div">
                            <div class="cantact-info">
                                <p class="p1">动脉橙-大橙子</p>
                                <p class="p2">微信：vcbeat_m</p>
                                <p class="p2">邮箱：liu.y@vcbeat.net</p>
                            </div>
                            <div class="cantact-img">
                                <img src="https://cdn.vcbeat.top/upload/vcbeat/public/Computer/Public/img/Show/ewm_jy.png" />
                            </div>
                        </div>
                    </li>
                </ul>
                <p class="records"> &copy; 动脉网 渝ICP备18013108号</p>
            </div>
        </div>
        <div class="loading2" v-if="loading">
            <div class="loading2_cnt">加载中<div class="loader-box"></div></div>
        </div>
    </div>
</template>

<script>
import { getMeta, addPuv, customReportDetail, chapterDetail, chapterModuleContent, previewReport,wxShare } from '../service'
import { share } from 'mobile/js/wx_share'
import filter from 'js/filter'
export default {
  data() {
    return {
      isOpen: false,

      loading: true,
      filter: filter,

      params: {
        uid: this.$route.params.uid
      },

      chapter_params: {
        chapter_id: '',
        custom_report_id: '',
        chapter_date:''
      },

      custom_report_detail: '',
      chapter_list: [],

      chapter_detail: '',
      chapter_module: [],

      module_list: {},
      insight: {},

      show_all_list: {},

      scroll_top: 0,
      temp_top_arr: [],
      slide_id: '',

      chapter_list_show: false,

      dynview_tag: [],
      dynview_tag_type: [],
      round: []
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
    // dynview_tag() {
    //   return this.$store.state.dynview_tag
    // },
    // dynview_tag_type() {
    //   return this.$store.state.dynview_tag_type
    // },
    chapter_num() {
      return function(chapter_id) {
        let index = this.chapter_list.findIndex((a) => a.id == chapter_id)
        return this.chapter_list[index].num
      }
    },
    entity_list() {
      return function (list) {
        let arr = []
        var dt = this.dynview_tag
        var dtt = this.dynview_tag_type
        for(var a = 0; a < list.length; a++) {
          var temp = []
          for(var b = 0; b < list[a].tag.length; b++) {
            var c = this.handleTag(dt, dtt, list[a].tag[b])
            var d = this.handleFindTag(c.type.id, temp)
            if(d) {
              d.arr.push(c.tag)
            } else {
              temp.push({
                id: c.type.id,
                name: c.type.name,
                arr: [c.tag]
              })
            }
          }
          arr.push({
            description: list[a].description,
            full_name: list[a].full_name,
            id: list[a].id,
            latest_event: list[a].latest_event,
            logo_path: list[a].logo_path,
            round_id: list[a].round_id,
            short_name: list[a].short_name,
            summary: list[a].summary,
            tag: list[a].tag,
            uid: list[a].uid,
            type: list[a].type,
            temp: temp
          })
        }
        return arr
      }
    },
    link_keyword() {
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1])
        }
      }
      return theRequest
    },
    user_key() {
      return this.$store.state.user_key
    },
    img_req_url() {
      return this.$store.state.img_req_url
    }
  },
  methods: {
    async getMeta() {
      let res = await getMeta({
        name: ['dynview_tag','dynview_tag_type','round']
      }, (error) => this.$Message.error('请求错误！'))
      if (res.status == 'success') {
        this.dynview_tag = res.meta.dynview_tag
        this.dynview_tag_type = res.meta.dynview_tag_type
        this.round = res.meta.round
        if(this.$route.name === 'MBriefReport') {
          this.getCustomReportDetail()
        } else {
          this.previewReport()
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: this.custom_report_detail.id
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    async getCustomReportDetail() {
      let res = await customReportDetail(this.params, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'custom_report_detail', res.res[0])
        this.$set(this.$data, 'chapter_list', res.chapter)
        this.chapter_params.chapter_id = this.chapter_list[0].id
        this.chapter_params.chapter_date = this.chapter_list[0].publish_time
        this.chapter_params.custom_report_id = this.custom_report_detail.id
        this.getChapterDetail()
        this.getAddPuv()
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
    * 预览
    */
    async previewReport() {
      let res = await previewReport(this.params, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'custom_report_detail', res.res[0])
        this.$set(this.$data, 'chapter_list', res.chapter)

        if(this.link_keyword.active) {
          this.chapter_params.chapter_id = this.link_keyword.active
        }else {
          this.chapter_params.chapter_id = this.chapter_list[this.chapter_list.length - 1].id
        }

        this.chapter_params.custom_report_id = this.custom_report_detail.id
        this.getChapterDetail()
        this.getAddPuv()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getChapterDetail() {
      let res = await chapterDetail(this.chapter_params, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'chapter_detail', res.res[0])
        this.$set(this.$data, 'chapter_module', res.module)
        res.module.map((a) => {
          this.getChapterModuleContent(a.id)
          this.show_all_list[a.id] = false
        })
        this.themeShare()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getChapterModuleContent(module_id) {
      let module_params = {
        chapter_id: this.chapter_params.chapter_id,
        module_id: module_id
      }
      let res = await chapterModuleContent(module_params, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.module_list[module_id] = res.content
        this.insight[module_id] = res.insight
        this.$forceUpdate()
        this.loading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    handleTag(dt, dtt, id) {
      var own = this.handleFindTag(id, dt);
      var type
      if (own.pid == null && own.pgid == null) {
        type = this.handleFindTag(own.type_id, dtt)
      } else if (own.pid != null && own.pgid == null) {
        type = this.handleFindTag(this.handleFindTag(own.pid, dt).type_id, dtt)
      } else {
        type = this.handleFindTag(this.handleFindTag(own.pgid, dt).type_id, dtt)
      }
      return {
        type: type,
        tag: own
      }
    },
    handleFindTag(id, arr) {
      for(var a = 0; a < arr.length; a++){
        if (arr[a].id == id) {
          return arr[a]
          break
        }
      }
    },
    /**
    * 导航点击事件
    * item 点击的对象
    */
    haddleModelSlider(module_id) {
      let targetTop
      if(module_id !== '') {
        targetTop = $('#tempLi' + module_id).offset().top - 50 //滚动条目标位置
      } else {
        targetTop = 0
      }
      $('html, body').animate({ scrollTop: targetTop }, 200)
      // this.isOpen = !this.isOpen
    },
    /**
    * 监听滚动条改变
    * 导航高亮
    */
    haddleScroll() {
      this.scroll_top = document.documentElement.scrollTop || document.body.scrollTop  //滚动条的值
      this.temp_top_arr = []
      this.chapter_module.map((a) => {
        this.temp_top_arr.push({
          module_id: a.id,
          offset_top: $('#tempLi' + a.id).offset().top - 109
        })
      })
      this.temp_top_arr.push({
        module_id: '',
        offset_top: 0
      })
      this.temp_top_arr.sort((a,b) => a.offset_top - b.offset_top)
      for(let i = 0; i < this.temp_top_arr.length; i++) {
        if(this.scroll_top >= this.temp_top_arr[i].offset_top) {
          this.slide_id = this.temp_top_arr[i].module_id
        }
      }
      this.$forceUpdate()
    },
    showAllList(item_id) {
      this.show_all_list[item_id] = !this.show_all_list[item_id]
      this.$forceUpdate()
    },
    haddleChangeChapter(value,date) {
      this.chapter_params.chapter_id = value
      this.chapter_params.chapter_date = date
      this.chapter_list_show = !this.chapter_list_show
      $('html, body').animate({ scrollTop: 0 }, 200)
      this.getChapterDetail()
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: this.custom_report_detail.id
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    },
    async themeShare() {
      let res = await wxShare({"url":this.$store.state.index_path+"/mindex" + this.$route.fullPath},
        (error) => { this.$Message.error('请求错误!') }
      )
      share(res, {
        title: '动脉微报',
        desc: this.chapter_detail.title,
        link: this.$store.state.index_path + '/mindex' + this.$route.fullPath,
        imgUrl: this.chapter_detail.share_logo_path ? (this.img_req_url + this.chapter_detail.share_logo_path):this.$store.state.static_img_url+'/favicon.ico',
      }, this, window.location.href)
    },
    getDate(date){
      if(date == null || date == ''){
        return date
      }
      return moment(date).format('YYYY/MM/DD');
    },
    goBack(){
      $('html, body').animate({ scrollTop: 0 }, 200)
    }
  },
  created() {
    this.getMeta()
  },
  mounted() {
    let _that = this
    window.onscroll = function(){
      _that.haddleScroll()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~mobile/styles/briefReport.stylus'
</style>
